import { LanguageDto } from "../languagedto";
import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";

export class CoinDto {
    decimalAdjustment?: number;
    currencyCode?: string;
    currencyTraductionDto?: CurrencyTraductionDto[] = [];
    periodBaseCurrencyDto?: PeriodBaseCurrencyDto[] = [];
    constructor(data?: Partial<CoinDto>) {
        Object.assign(this, data);
    }
}

export class CurrencyTraductionDto {
    currencyTraductionPkDto: currencyTraductionPkDto[] = [];
    description? : string;
    languageDto?: LanguageDto;
}

export class currencyTraductionPkDto {
    currencyCode? : string;
    languageId?: number;
}

export class PeriodBaseCurrencyPkDto {
    currencyCode? : string;
    startDate?: number;
}

export class PeriodBaseCurrencyDto {
    periodBaseCurrencyPkDto?:PeriodBaseCurrencyPkDto
    currencyDto? : string;
    endDate?: number;
}

export class CoinResponse {
    coinDto: CoinDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class CoinRequest {
    coinDto: CoinDto = new CoinDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}